DetailOutput = App.loadClass 'core::reports/DetailOutput'
BaseOutput = App.loadClass 'core::reports/BaseOutput'
BaseHandler = App.loadClass 'core::reports/BaseHandler'

class exports.ReportsRuppOrdersSubHandler extends BaseHandler
    init: () ->
        @layoutSelector = '#reports_rupp_orders_tab'
        @layoutUrl      = 'backend/portal/reports/rupp-orders/table/detail'
        @excelUrl       = 'backend/portal/reports/rupp-orders/excel'
        @filterUrl      = 'backend/portal/reports/rupp-orders/filters'
        @currentOutput = new DetailOutput this, @parent, 'auto', { sAjaxSource: 'backend/portal/reports/rupp-orders/output/detail' }
        @initFilters()


    initFilters: () ->
        @resetFilters()

        @parent.filters.removeGroup 'Region Filters'
        @parent.filters.removeGroup 'Operation Filters'

        @parent.filters.importGroup
            name: 'Orders Filters'
            filters: [
                {
                    name: 'categories'
                    display_name: 'Item Category'
                    class: 'dropup'
                },
                {
                    name: 'years'
                    display_name: 'Sales Year'
                    class: 'dropup'
                },
                {
                    name: 'states'
                    display_name: 'State'
                    class: 'dropup'
                },
                {
                    name: 'zips'
                    display_name: 'ZIP Code'
                    class: 'dropup'
                },
                {
                    name: 'zones'
                    display_name: 'Pricing Zone'
                    class: 'dropup'
                },
                {
                    name: 'reps'
                    display_name: 'Sales Rep'
                    class: 'dropup'
                },
                {
                    name: 'operations'
                    display_name: 'Company'
                    class: 'dropup'
                },
                {
                    name: 'customers'
                    display_name: 'Customer'
                    class: 'dropup'
                },
                {
                    name: 'orders'
                    display_name: 'Order #'
                    class: 'dropup'
                },
                {
                    name: 'trait_packages'
                    display_name: 'Trait Package'
                    class: 'dropup'
                },
                {
                    name: 'products'
                    display_name: 'Product'
                    class: 'dropup'
                },
                {
                    name: 'treatments'
                    display_name: 'Treatment'
                    class: 'dropup'
                },
                {
                    name: 'units_of_measure'
                    display_name: 'UoM'
                    class: 'dropup'
                },
                {
                    name: 'start_date'
                    display_name: 'Delivery Start Date'
                    control_type: 'datepicker'
                },
                {
                    name: 'end_date'
                    display_name: 'Delivery End Date'
                    control_type: 'datepicker'
                },
            ]

        year = @parent.filters.findInGroup 'years'
        year.control_type = 'single_dropdown'
        year.deletable = false

        @setDefaultsAndRun(0, 5, 17)


    destroy: () ->
        @parent.filters.removeGroup 'Orders Filters'
        @importDefaultFilters()
        super()
